import { Services, checkHostnames, publicDocuments } from '@sigma-frontend-libs/commons'

import { hostnames, validation } from '@/utils'

import render from './render'

export const consentsTypes = Object.keys(publicDocuments)

export default {
  name: 'Consents',

  mixins: [ validation ],

  data() {
    const consents = {}
    for (const type of consentsTypes) {
      consents[type] = false
    }

    return {
      consents
    }
  },

  computed: {
    isConsentsRequired() {
      return checkHostnames(hostnames)
    },

    labels() {
      const result = {}

      for (const type of consentsTypes) {
        let document = this.getTranslate(`${Services.registration}.labels.${type}.document`)
        const href = publicDocuments[type]
        if (href) {
          document = `<a href="${href}" class="link" target="_blank" rel="noopener noreferrer">${document}</a>`
        }
        result[type] = this.getTranslate(`${Services.registration}.labels.${type}.title`, { document })
      }

      return result
    },

    validation() {
      if (this.isConsentsRequired) {
        return Object.values(this.consents).every(Boolean)
      }

      return true
    }
  },

  render
}
